// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2C_Ub","Logo":"Header_Logo__18l3V","DesktopOnly":"Header_DesktopOnly__xEHIF"};